import { FC } from 'react'
import { Home } from './connect.page'

const ConnectPage: FC = () => {
    return <Home />
}

export default ConnectPage
